import { FC, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { SuspenseLoader } from "@shared/ui/Loader";
import {
  useGetCaseProductsQuery,
  useGetUserCaseProgressQuery,
  useBuyCaseMutation,
} from "@entities/Case/CaseApi";
import { Case } from "@shared/ui/Cases/Cases";
import styles from "./styles.module.css";
import ProgressArc from "@shared/ui/HalfCircleProgressBar/ui/HalfCircleProgressBar";
import { InfoButton } from "@shared/ui/Buttons/InfoButton/InfoButton";

const GAME_POINTS = [
  { action: "Kill", points: 10 },
  { action: "Assist", points: 3 },
  { action: "Headshot", points: 5 },
  { action: "Win", points: 100 },
  { action: "Triple-Kill", points: 60 },
  { action: "Quadro-Kill", points: 100 },
  { action: "Ace", points: 200 },
  { action: "MVP", points: 30 },
] as const;

// SVG компонент для иконки предупреждения
const WarningIcon = (
  <svg
    width="56"
    height="48"
    viewBox="0 0 56 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.7752 3.48793C27.8438 3.45109 27.921 3.4322 27.9992 3.43308C28.0763 3.43278 28.1521 3.45166 28.2197 3.48793C28.2993 3.53548 28.3645 3.60292 28.4087 3.68334L52.4057 43.6804C52.5317 43.8861 52.5282 44.1055 52.4127 44.3078C52.3647 44.3882 52.3004 44.4582 52.2238 44.5135C52.1561 44.5588 52.0744 44.5794 51.9928 44.5718H4.00564C3.92406 44.5794 3.84232 44.5588 3.77467 44.5135C3.69806 44.4582 3.63375 44.3882 3.58569 44.3078C3.52948 44.2122 3.50049 44.1035 3.50172 43.9932C3.50295 43.8828 3.53436 43.7748 3.59269 43.6804L27.5863 3.68334C27.6304 3.60292 27.6957 3.53548 27.7752 3.48793ZM31.4289 1.94523C31.0824 1.35408 30.5829 0.86294 29.9807 0.521396C29.3786 0.179852 28.695 0 27.9992 0C27.3034 0 26.6199 0.179852 26.0177 0.521396C25.4155 0.86294 24.916 1.35408 24.5696 1.94523L0.572492 41.9423C-1.02685 44.6095 0.890959 48 4.00214 48H51.9928C55.104 48 57.0253 44.6061 55.4224 41.9423L31.4289 1.94523Z"
      fill="black"
    />
    <path
      d="M27.7752 3.48793C27.8438 3.45109 27.921 3.4322 27.9992 3.43308C28.0763 3.43278 28.1521 3.45166 28.2197 3.48793C28.2993 3.53548 28.3645 3.60292 28.4087 3.68334L52.4057 43.6804C52.5317 43.8861 52.5282 44.1055 52.4127 44.3078C52.3647 44.3882 52.3004 44.4582 52.2238 44.5135C52.1561 44.5588 52.0744 44.5794 51.9928 44.5718H4.00564C3.92406 44.5794 3.84232 44.5588 3.77467 44.5135C3.69806 44.4582 3.63375 44.3882 3.58569 44.3078C3.52948 44.2122 3.50049 44.1035 3.50172 43.9932C3.50295 43.8828 3.53436 43.7748 3.59269 43.6804L27.5863 3.68334C27.6304 3.60292 27.6957 3.53548 27.7752 3.48793ZM31.4289 1.94523C31.0824 1.35408 30.5829 0.86294 29.9807 0.521396C29.3786 0.179852 28.695 0 27.9992 0C27.3034 0 26.6199 0.179852 26.0177 0.521396C25.4155 0.86294 24.916 1.35408 24.5696 1.94523L0.572492 41.9423C-1.02685 44.6095 0.890959 48 4.00214 48H51.9928C55.104 48 57.0253 44.6061 55.4224 41.9423L31.4289 1.94523Z"
      fill="#FB3F50"
    />
    <path
      d="M27.7752 3.48793C27.8438 3.45109 27.921 3.4322 27.9992 3.43308C28.0763 3.43278 28.1521 3.45166 28.2197 3.48793C28.2993 3.53548 28.3645 3.60292 28.4087 3.68334L52.4057 43.6804C52.5317 43.8861 52.5282 44.1055 52.4127 44.3078C52.3647 44.3882 52.3004 44.4582 52.2238 44.5135C52.1561 44.5588 52.0744 44.5794 51.9928 44.5718H4.00564C3.92406 44.5794 3.84232 44.5588 3.77467 44.5135C3.69806 44.4582 3.63375 44.3882 3.58569 44.3078C3.52948 44.2122 3.50049 44.1035 3.50172 43.9932C3.50295 43.8828 3.53436 43.7748 3.59269 43.6804L27.5863 3.68334C27.6304 3.60292 27.6957 3.53548 27.7752 3.48793ZM31.4289 1.94523C31.0824 1.35408 30.5829 0.86294 29.9807 0.521396C29.3786 0.179852 28.695 0 27.9992 0C27.3034 0 26.6199 0.179852 26.0177 0.521396C25.4155 0.86294 24.916 1.35408 24.5696 1.94523L0.572492 41.9423C-1.02685 44.6095 0.890959 48 4.00214 48H51.9928C55.104 48 57.0253 44.6061 55.4224 41.9423L31.4289 1.94523Z"
      fill="#F2EB56"
      fillOpacity="0.16"
    />
    <path
      d="M24.5 37.7142C24.5 37.264 24.5905 36.8182 24.7664 36.4022C24.9423 35.9863 25.2001 35.6084 25.525 35.2901C25.85 34.9717 26.2358 34.7192 26.6604 34.5469C27.085 34.3746 27.5401 34.2859 27.9996 34.2859C28.4592 34.2859 28.9143 34.3746 29.3389 34.5469C29.7635 34.7192 30.1493 34.9717 30.4743 35.2901C30.7992 35.6084 31.057 35.9863 31.2329 36.4022C31.4088 36.8182 31.4993 37.264 31.4993 37.7142C31.4993 38.6234 31.1306 39.4954 30.4743 40.1383C29.818 40.7812 28.9278 41.1424 27.9996 41.1424C27.0715 41.1424 26.1813 40.7812 25.525 40.1383C24.8687 39.4954 24.5 38.6234 24.5 37.7142ZM24.843 17.1277C24.7964 16.6952 24.8431 16.2579 24.9802 15.8443C25.1172 15.4306 25.3415 15.0498 25.6385 14.7265C25.9355 14.4033 26.2986 14.1448 26.7041 13.9678C27.1097 13.7909 27.5487 13.6995 27.9926 13.6995C28.4366 13.6995 28.8756 13.7909 29.2812 13.9678C29.6867 14.1448 30.0498 14.4033 30.3468 14.7265C30.6438 15.0498 30.8681 15.4306 31.0051 15.8443C31.1422 16.2579 31.1889 16.6952 31.1423 17.1277L29.9175 29.1505C29.8763 29.6228 29.6557 30.0628 29.2993 30.3834C28.9428 30.704 28.4766 30.8819 27.9926 30.8819C27.5087 30.8819 27.0425 30.704 26.686 30.3834C26.3296 30.0628 26.109 29.6228 26.0678 29.1505L24.843 17.1277Z"
      fill="black"
    />
    <path
      d="M24.5 37.7142C24.5 37.264 24.5905 36.8182 24.7664 36.4022C24.9423 35.9863 25.2001 35.6084 25.525 35.2901C25.85 34.9717 26.2358 34.7192 26.6604 34.5469C27.085 34.3746 27.5401 34.2859 27.9996 34.2859C28.4592 34.2859 28.9143 34.3746 29.3389 34.5469C29.7635 34.7192 30.1493 34.9717 30.4743 35.2901C30.7992 35.6084 31.057 35.9863 31.2329 36.4022C31.4088 36.8182 31.4993 37.264 31.4993 37.7142C31.4993 38.6234 31.1306 39.4954 30.4743 40.1383C29.818 40.7812 28.9278 41.1424 27.9996 41.1424C27.0715 41.1424 26.1813 40.7812 25.525 40.1383C24.8687 39.4954 24.5 38.6234 24.5 37.7142ZM24.843 17.1277C24.7964 16.6952 24.8431 16.2579 24.9802 15.8443C25.1172 15.4306 25.3415 15.0498 25.6385 14.7265C25.9355 14.4033 26.2986 14.1448 26.7041 13.9678C27.1097 13.7909 27.5487 13.6995 27.9926 13.6995C28.4366 13.6995 28.8756 13.7909 29.2812 13.9678C29.6867 14.1448 30.0498 14.4033 30.3468 14.7265C30.6438 15.0498 30.8681 15.4306 31.0051 15.8443C31.1422 16.2579 31.1889 16.6952 31.1423 17.1277L29.9175 29.1505C29.8763 29.6228 29.6557 30.0628 29.2993 30.3834C28.9428 30.704 28.4766 30.8819 27.9926 30.8819C27.5087 30.8819 27.0425 30.704 26.686 30.3834C26.3296 30.0628 26.109 29.6228 26.0678 29.1505L24.843 17.1277Z"
      fill="#FB3F50"
    />
    <path
      d="M24.5 37.7142C24.5 37.264 24.5905 36.8182 24.7664 36.4022C24.9423 35.9863 25.2001 35.6084 25.525 35.2901C25.85 34.9717 26.2358 34.7192 26.6604 34.5469C27.085 34.3746 27.5401 34.2859 27.9996 34.2859C28.4592 34.2859 28.9143 34.3746 29.3389 34.5469C29.7635 34.7192 30.1493 34.9717 30.4743 35.2901C30.7992 35.6084 31.057 35.9863 31.2329 36.4022C31.4088 36.8182 31.4993 37.264 31.4993 37.7142C31.4993 38.6234 31.1306 39.4954 30.4743 40.1383C29.818 40.7812 28.9278 41.1424 27.9996 41.1424C27.0715 41.1424 26.1813 40.7812 25.525 40.1383C24.8687 39.4954 24.5 38.6234 24.5 37.7142ZM24.843 17.1277C24.7964 16.6952 24.8431 16.2579 24.9802 15.8443C25.1172 15.4306 25.3415 15.0498 25.6385 14.7265C25.9355 14.4033 26.2986 14.1448 26.7041 13.9678C27.1097 13.7909 27.5487 13.6995 27.9926 13.6995C28.4366 13.6995 28.8756 13.7909 29.2812 13.9678C29.6867 14.1448 30.0498 14.4033 30.3468 14.7265C30.6438 15.0498 30.8681 15.4306 31.0051 15.8443C31.1422 16.2579 31.1889 16.6952 31.1423 17.1277L29.9175 29.1505C29.8763 29.6228 29.6557 30.0628 29.2993 30.3834C28.9428 30.704 28.4766 30.8819 27.9926 30.8819C27.5087 30.8819 27.0425 30.704 26.686 30.3834C26.3296 30.0628 26.109 29.6228 26.0678 29.1505L24.843 17.1277Z"
      fill="#F2EB56"
      fillOpacity="0.16"
    />
  </svg>
);

export const CasePage: FC = () => {
  const navigate = useNavigate();
  const caseId = window.location.pathname.split("/").pop() || "";
  const [isFinishing, setIsFinishing] = useState(false);

  // Запрос на список продуктов (награды) в кейсе
  const { data: productsData, isLoading: isProductsLoading } =
    useGetCaseProductsQuery(caseId);

  // Запрос на прогресс пользователя по кейсу (очки, купил ли и т.д.)
  const {
    data: userProgressData,
    isLoading: isUserProgressLoading,
    refetch: refetchUserProgress,
  } = useGetUserCaseProgressQuery();

  // Мутация для покупки кейса
  const [buyCase, { isLoading: isPurchasing }] = useBuyCaseMutation();

  const handleBack = () => {
    navigate({ to: "/shop/select-case" });
  };

  const handlePurchase = async () => {
    try {
      const response = await buyCase(caseId).unwrap();

      if (response.success) {
        refetchUserProgress();
      }
    } catch (error) {
      console.error("Error purchasing case:", error);
    }
  };

  // Обработчик для кнопки FINISH
  const handleFinish = () => {
    setIsFinishing(true);
    // Здесь ваша логика для завершения кейса
    // Например, вызов API для закрытия кейса или обновления статуса
    setTimeout(() => {
      // Имитация запроса к API
      setIsFinishing(false);
      // После успешного завершения можно выполнить редирект или обновить данные
      navigate({ to: "/shop/select-case" });
    }, 1500);
  };

  // Показываем лоадер, пока данные грузятся
  if (isProductsLoading || isUserProgressLoading) {
    return <SuspenseLoader />;
  }

  // Если не нашли товары
  if (!productsData?.caseProducts) {
    return (
      <div className={styles.error}>
        <h2>Case not found</h2>
        <button onClick={handleBack}>Back to cases</button>
      </div>
    );
  }

  // Из прогресса достаём нужные поля
  const userProgress = userProgressData?.userCaseProgress.find(
    (progress) => progress.caseId === caseId
  );
  const purchased = Boolean(userProgress);
  const points = userProgress?.points || 0;
  const remainingGames = userProgress?.remainingGames || 0;

  // Максимальное число очков - 5000, как в макете
  const maxPoints = 5000;
  // Общее количество игр (предполагаем 5)
  const totalGames = 5;
  // Сколько игр уже сыграно
  const playedGames = totalGames - remainingGames;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {purchased ? (
          <div className={styles.leftSection}>
            <div className={styles.caseProgressWrapper}>
              <div className={styles.darkCase}>
                <Case />
              </div>

              <div className={styles.progressOverlay}>
                <ProgressArc
                  score={points}
                  currentGame={playedGames}
                  maxScore={maxPoints}
                  size={450}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.leftSection}>
            <Case />
          </div>
        )}

        {/* Правая часть: «HOW TO GAIN POINTS», «REWARDS», кнопка PURCHASE/FINISH */}
        <div className={styles.rightSection}>
          <h2 className={styles.title}>HOW TO GAIN POINTS: CS:GO</h2>
          <div className={styles.pointsContainer}>
            <div className={styles.pointColumn}>
              {GAME_POINTS.slice(0, GAME_POINTS.length / 2).map(
                (point, index) => (
                  <div key={index} className={styles.pointRow}>
                    <span className={styles.action}>{point.action}</span>
                    <span className={styles.points}>{point.points}</span>
                  </div>
                )
              )}
            </div>
            <div className={styles.divider} />
            <div className={styles.pointColumn}>
              {GAME_POINTS.slice(GAME_POINTS.length / 2).map((point, index) => (
                <div key={index} className={styles.pointRow}>
                  <span className={styles.action}>{point.action}</span>
                  <span className={styles.points}>{point.points}</span>
                </div>
              ))}
            </div>
          </div>

          <h2 className={styles.title}>REWARDS</h2>
          <div className={styles.rewardsContainer}>
            {productsData.caseProducts
              .slice()
              .sort((a, b) => a.price - b.price)
              .map((product, index, sortedArray) => {
                const isCurrent =
                  points >= product.price &&
                  (index === sortedArray.length - 1 ||
                    points < sortedArray[index + 1].price);

                return (
                  <div
                    key={product.id}
                    className={`${styles.rewardItem} ${isCurrent ? styles.status : ""}`}
                  >
                    <div
                      className={styles.rewardImage}
                      style={{
                        backgroundImage: `url(${product.imageLink})`,
                      }}
                    />
                    <span className={styles.rewardPrice}>{product.price}</span>
                  </div>
                );
              })}
          </div>

          {/* 
            Заменяем кнопку PURCHASE на FINISH и добавляем иконку предупреждения рядом,
            если кейс куплен
          */}
          {purchased ? (
            <div className={styles.finishContainer}>
              <div className={styles.warningIconWrapper}>
                <InfoButton tooltip="You can open the case only after you finish the game" icon={WarningIcon} />
              </div>
              <button
                className={`${styles.purchaseButton} ${styles.finishButton}`}
                onClick={handleFinish}
                disabled={isFinishing}
              >
                {isFinishing ? "FINISHING..." : "FINISH"}
              </button>
            </div>
          ) : (
            <button
              className={styles.purchaseButton}
              onClick={handlePurchase}
              disabled={isPurchasing || isProductsLoading}
            >
              {isPurchasing ? "PURCHASING..." : "PURCHASE"} <strong>5</strong>
              <svg
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_dd_934_4963)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 24C19.6274 24 25 18.6274 25 12C25 5.37258 19.6274 0 13 0C6.37258 0 1 5.37258 1 12C1 18.6274 6.37258 24 13 24ZM14.5 4.50316V3L11.5 3V4.50375C10.3411 4.54169 9.43705 4.86703 8.78793 5.47978C8.09598 6.13297 7.75 7.07387 7.75 8.30249L7.75 15.6975C7.75 16.9261 8.09598 17.867 8.78793 18.5202C9.43705 19.133 10.3411 19.4583 11.5 19.4962V21.0004H14.5V19.4969C15.6549 19.4623 16.5589 19.1368 17.2121 18.5202C17.904 17.8515 18.25 16.9106 18.25 15.6975L18.25 11.8017C18.25 11.444 18.0649 11.2652 17.6948 11.2652H13.4707C13.1328 11.2652 12.9638 11.4285 12.9638 11.7551V13.3414C12.9638 13.668 13.1328 13.8313 13.4707 13.8313H14.919C15.096 13.8313 15.1845 13.9168 15.1845 14.0879V15.5575C15.1845 16.0552 15.0799 16.4129 14.8707 16.6306C14.6615 16.8328 14.2994 16.9339 13.7845 16.9339H12.2155C11.7167 16.9339 11.3546 16.8328 11.1293 16.6306C10.9201 16.4129 10.8155 16.0552 10.8155 15.5575V8.44246C10.8155 7.94479 10.9201 7.59487 11.1293 7.39269C11.3546 7.17496 11.7167 7.0661 12.2155 7.0661H13.7845C14.2994 7.0661 14.6615 7.17496 14.8707 7.39269C15.0799 7.59487 15.1845 7.94479 15.1845 8.44246V9.00233C15.1845 9.34448 15.3534 9.51555 15.6914 9.51555H17.7431C18.081 9.51555 18.25 9.34448 18.25 9.00233V8.30249C18.25 7.08942 17.904 6.1563 17.2121 5.50311C16.5589 4.87189 15.6549 4.53858 14.5 4.50316Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_dd_934_4963"
                    x="0"
                    y="0"
                    width="26"
                    height="24"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="1" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.988235 0 0 0 0 0 0 0 0 0.266667 0 0 0 0.56 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_934_4963"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0.996078 0 0 0 0.988235 0 0 0 0.64 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_dropShadow_934_4963"
                      result="effect2_dropShadow_934_4963"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect2_dropShadow_934_4963"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
